import { useEffect, useReducer } from "react";

import { useCardProvider } from "Payments/globalPaymentsStateHooks";

import CreditCard from "./CreditCard";
import Stax from "./Stax";
import WePay from "./WePay";
import cardTypes from "./cardTypes.js";
import useCreditCardEntryState, { CreditCardEntryProvider } from "./state.js";

function CreditCardEntry({
  getPaymentMethodTokenTrigger,
  setPaymentMethodTokenInfo,
  show,
  isAlreadyExisting,
  setInputErrors,
  shouldClearDisplayMessages,
  setShouldClearDisplayMessages,
  submitting,
  ...ccData
}) {
  const [state, dispatch] = useCreditCardEntryState();
  const [mounted, mount] = useReducer(() => true, false);
  const [initialized, initialize] = useReducer(() => true, false);
  const { providerIsStax } = useCardProvider();

  useEffect(() => {
    if (isAlreadyExisting && !mounted) {
      dispatch({
        type: "Set Existing Card Data",
        payload: {
          ...ccData,
          name:
            ccData.accountHolderName ||
            `${ccData.owner.fname || ""} ${ccData.owner.lname || ""}`,
          month: ccData.expirationMonth || "",
          year: ccData.expirationYear.slice(-2) || "",
          cardType: cardTypes.find((c) => c.shortname === ccData.cardType),
          canBeEdited: true,
        },
      });
      mount();
    } else if (!isAlreadyExisting && !initialized) {
      if (ccData.existingUserName)
        dispatch({ type: "Set Name", name: ccData.existingUserName });
      if (ccData.existingZip)
        dispatch({ type: "Set Zip", zip: ccData.existingZip });
      initialize();
    }
  }, [isAlreadyExisting, dispatch, ccData, mounted, initialized]);

  if (providerIsStax) {
    return (
      <Stax
        getPaymentMethodTokenTrigger={getPaymentMethodTokenTrigger}
        setPaymentMethodTokenInfo={setPaymentMethodTokenInfo}
        setInputErrors={setInputErrors}
      >
        <CreditCard
          show={show}
          isAlreadyExisting={isAlreadyExisting}
          setInputErrors={setInputErrors}
          shouldClearDisplayMessages={shouldClearDisplayMessages}
          setShouldClearDisplayMessages={setShouldClearDisplayMessages}
          submitting={submitting}
          {...ccData}
        />
      </Stax>
    );
  }

  return (
    <>
      <WePay
        getPaymentMethodTokenTrigger={getPaymentMethodTokenTrigger}
        setPaymentMethodTokenInfo={setPaymentMethodTokenInfo}
        setInputErrors={setInputErrors}
      >
        <CreditCard
          show={show}
          isAlreadyExisting={isAlreadyExisting}
          setInputErrors={setInputErrors}
          shouldClearDisplayMessages={shouldClearDisplayMessages}
          setShouldClearDisplayMessages={setShouldClearDisplayMessages}
          submitting={submitting}
          {...ccData}
        />
      </WePay>
    </>
  );

  return null;
}

export default function CreditCardEntryWithProvider(props) {
  const { initialAppState, ...rest } = props;

  return (
    <CreditCardEntryProvider initialAppState={initialAppState}>
      <CreditCardEntry {...rest} />
    </CreditCardEntryProvider>
  );
}
